import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import * as React from 'react';
import 'moment/locale/nl';
import moment from 'moment';

import Layout from './src/components/Layout';

const cache = createCache({
  key: 'css',
  prepend: true,
});

export const wrapRootElement = ({
  element,
}: {
  element: React.ReactElement;
}) => {
  const language = process.env.GATSBY_LANGUAGE || 'en';
  moment.locale(language);

  return (
    <CacheProvider value={cache}>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={language}
      >
        {element}
      </LocalizationProvider>
    </CacheProvider>
  );
};

export const wrapPageElement = ({
  element,
  props,
}: {
  element: React.ReactElement;
  props: any;
}) => {
  return <Layout {...props}>{element}</Layout>;
};
